"use client"
import { Link, useNavigate } from "react-router-dom"
import Logo from "../images/Logo.png"
import DarkMode from "../Components/Navbar/DarkMode"
import { FaSignOutAlt, FaUserShield } from "react-icons/fa"

const AdminNavbar = () => {
  const navigate = useNavigate()

  const handleSignOut = () => {
    const confirmSignOut = window.confirm("Are you sure you want to sign out?")
    if (confirmSignOut) {
      // Clear authentication tokens
      localStorage.removeItem("adminToken")
      localStorage.removeItem("userToken")
      sessionStorage.removeItem("adminSession")
      sessionStorage.clear()

      // Redirect to home page
      navigate("/")

      // Optional: Show success message
      setTimeout(() => {
        alert("Successfully signed out!")
      }, 100)
    }
  }

  return (
    <>
      <div className="shadow-md bg-white dark:bg-gray-900 dark:text-white duration-200 relative z-40">
        {/* Upper Navbar */}
        <div className="bg-primary/90 py-2">
          <div className="container mx-auto flex justify-between items-center px-4">
            <div className="flex items-center">
              <Link to="/" className="text-2xl sm:text-3xl flex gap-2 items-center">
                <div className="bg-white rounded-full p-1 hover:scale-105 transition-transform duration-300">
                  <img src={Logo || "/placeholder.svg"} alt="Logo" className="logo w-12 md:w-16 rounded-full" />
                </div>
                <span style={{ fontWeight: "bold", color: "White" }}>IIChE AVVU SC</span>
              </Link>
            </div>

            <div className="flex items-center gap-4">
              {/* Admin Indicator */}
              <div className="hidden sm:flex items-center gap-2 bg-white/20 rounded-full px-3 py-1">
                <FaUserShield className="text-white w-4 h-4" />
                <span className="text-white text-sm font-medium">Admin Panel</span>
              </div>

              <DarkMode />

              {/* Sign Out Button */}
              <button
                onClick={handleSignOut}
                className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg"
                title="Sign Out"
              >
                <FaSignOutAlt className="w-4 h-4" />
                <span className="hidden sm:inline">Sign Out</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AdminNavbar
